import styled from '@emotion/styled';
import { mainColors, navigation } from 'src/assets/colors';

export const TabNav = styled('nav', { label: 'TabNav' })`
    background-color: ${navigation.bgColor};
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    margin: 16px 0;
`;

interface TabNavItemPropsType {
    isActive: boolean;
}

export const TabNavItem = styled('button', { label: 'TabNavItem' })<TabNavItemPropsType>`
    background: ${({ isActive }): string => isActive ? '#a3ccb2' : '#bbb'};
    border-radius: 0;
    border: none;
    color: #fff;
    cursor: pointer;
    font-family: var(--fontFamilySecondary);
    font-size: 0.75rem;
    height: 30px;
    line-height: 1.4;
    padding: 4px 8px;
    text-align: center;
    transition: background-color .2s ease;
    &:not(:last-of-type) {
        margin-right: 8px;
    }
`;

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const SubPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 400px;
`;

export const ErrorMessage = styled('div', { label: 'ErrorMessage' })`
    padding: 5px 10px;
    color: ${mainColors.text.light};
    text-align: center;
    background-color: ${mainColors.status.error};
    border-radius: 3px;
    margin-bottom: 10px;
`;
